import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { LISTING_INTRO_SAMPLE } from "../consts";
import { getSelectedPictureUrls } from "../helpers";
import { ListingSceneProps } from "../types";
import AdImage from "./AdImage";

const THUMBNAIL_COUNT = 3;

/** Korak fotografija: naslovna i galerija (prave fotografije ako ih ima), broj odabranih i redoslijed. */
const PicturesScene: React.FC<ListingSceneProps> = ({ formValues }) => {
  const [, ...rest] = getSelectedPictureUrls(formValues);
  const thumbnails = Array.from({ length: THUMBNAIL_COUNT }, (_, index) => rest[index]);
  const hasPictures = formValues.pictures.length > 0;
  const selectedCount = hasPictures ? formValues.selectedPictureUploadIds.length : LISTING_INTRO_SAMPLE.pictureCount;
  const totalCount = hasPictures ? formValues.pictures.length : LISTING_INTRO_SAMPLE.pictureCount;
  const progress = totalCount > 0 ? Math.round((selectedCount / totalCount) * 100) : 0;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-3">
          <div className="relative">
            <AdImage formValues={formValues} className="h-[11.2rem] rounded-md" />
            <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-white/90 text-[0.6rem] font-semibold text-slate-700">
              Naslovna
            </span>
          </div>
          <div className="mt-2 grid grid-cols-3 gap-2">
            {thumbnails.map((picture, index) => (
              <div key={index} className="flex items-center justify-center h-14 rounded-md bg-slate-100 overflow-hidden">
                {picture ? (
                  <img src={picture} alt="" className="w-full h-full object-cover" />
                ) : (
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="3" y="3" width="18" height="18" rx="2" />
                    <circle cx="8.5" cy="8.5" r="1.5" />
                    <path d="M21 15l-5-5L5 21" />
                  </svg>
                )}
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Odabrane fotografije</div>
          <div className="mt-2 text-sm font-bold text-slate-800">
            {selectedCount} od {totalCount}
          </div>
          <div className="mt-3 h-1.5 rounded-full bg-slate-100">
            <div className="h-full rounded-full bg-gradient-to-r from-blue-500 to-sky-400" style={{ width: `${progress}%` }} />
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Prva je naslovna"
          subtitle="Redoslijed vrijedi za sve oglasnike"
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <path d="M21 15l-5-5L5 21" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(PicturesScene);
